import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_EXECUTORS = "fetchExecutors";
export const FETCH_EXECUTOR = "fetchExecutor";
export const SAVE_EXECUTOR = "saveExecutor";
export const UPDATE_EXECUTOR = "updateExecutor";
export const DELETE_EXECUTOR = "deleteExecutor";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingExecutors";
export const SET_EXECUTORS = "setExecutors";

const state = {
  executors_errors: [],
  executors: [],
  isLoadingExecutor: false
};

const getters = {
  isLoadingExecutor() {
    return state.isLoadingExecutor;
  },
  getExecutors() {
    return state.executors;
  }
};

const actions = {
  [FETCH_EXECUTORS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("executors" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_EXECUTOR](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("executors", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_EXECUTOR](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("executors", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_EXECUTOR](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("executors", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_EXECUTOR](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("executors", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingExecutors = false;
    if (Array.isArray(errors)) {
      state.executors_errors = errors;
    } else {
      state.executors_errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingExecutor = value;
  },
  [SET_EXECUTORS](state, data) {
    state.isLoadingExecutor = false;
    state.executors = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
